//Contact
function wu_tsa_contact_submit() {
       dataLayer.push({'event': 'gform_confirmation_loaded'});
}

$(document).bind('gform_confirmation_loaded', function(event, formId) {
        if (formId == 2) {
                wu_tsa_contact_submit();
        }
});


